import { useState, Fragment } from "react";
import { TableContainer, Table, TableHead, TableRow, TableBody, Divider, TablePagination, Paper, TableCell, tableCellClasses, IconButton, Checkbox, Typography, Stack } from "@mui/material";
import { dateFormmater, urlGetNextCall } from '../../../helpers';
import { styled } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PageviewIcon from '@mui/icons-material/Pageview';
import { useNavigate } from "react-router-dom";

export const NextCallTable = ({ data }) => {

    const navigate = useNavigate();

    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [page, setPage] = useState(0);
    const [asc, setAsc] = useState(false);

    const handleChangePage = (newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleClick = (i) => {    //ordenar columnas
        if (asc) {
            data.sort(function (a, b) {
                if (a[values[i]] > b[values[i]]) { return -1; }
                if (a[values[i]] < b[values[i]]) { return 1; }
                return 0
            });
        } else {
            data.sort(function (a, b) {
                if (a[values[i]] < b[values[i]]) { return -1; }
                if (a[values[i]] > b[values[i]]) { return 1; }
                return 0
            });
        }

        setAsc(!asc);
    }

    const handleView = (id) => {
        navigate('/viewEstimate?id='+id)
    }

    const handleChange = async (callMade, id) => {
        const token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken');
        const dataCallMade = data.filter(d => d.id === id)[0].callMade = !callMade;
        await fetch(urlGetNextCall, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ 'id': id, 'callMade': dataCallMade.toString() })
        })
    }

    return (
        <Fragment>
            {data.length === 0 ?
                (
                    <Stack width='100%'>
                        <Typography textAlign='center' mt='3rem' variant='h4'>No hay datos disponibles</Typography>
                    </Stack>
                )
                :
                (
                    <TableContainer component={Paper} mt={3}  >
                        <Table aria-label="customized table" >
                            <TableHead>
                                <TableRow>
                                    {colNames.map((d, i) => {
                                        return <StyledTableCell align={'center'} className='order' onClick={() => handleClick(i)} key={d}>{d} <ArrowDropDownIcon className='arrow' /> </StyledTableCell>
                                    })}
                                    <StyledTableCell align='right' />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((d) => (
                                    <StyledTableRow key={d.id}>
                                        <StyledTableCell align='center'> {d.addressWork} </StyledTableCell>
                                        <StyledTableCell align='center'> {d.contact} </StyledTableCell>
                                        <StyledTableCell align='center'> {d.tel} </StyledTableCell>
                                        <StyledTableCell align='center'> {d.email} </StyledTableCell>
                                        <StyledTableCell align='center'> {dateFormmater(d.dateCall)} </StyledTableCell>
                                        <StyledTableCell align='right'>
                                            <Checkbox size="small" onChange={() => handleChange(d.callMade, d.id)} defaultChecked={d.callMade} />
                                            <IconButton onClick={() => handleView(d.id)}>
                                                <PageviewIcon color='primary' />
                                            </IconButton>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )
                                )}

                            </TableBody>
                        </Table>
                        <Divider />
                        <TablePagination
                            rowsPerPageOptions={[25, 50, 100]}
                            component="div"
                            count={data.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            align='rigth'
                        />
                    </TableContainer>
                )
            }
        </Fragment>
    )
}

//Estilos
export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const colNames = ['Dirección de la obra', 'Contacto', 'Teléfono', 'Email', 'Llamar el:'];
const values = ['addressWork', 'contact', 'tel', 'email', 'dateCall']
